import React from 'react'
import {Button} from 'react-bootstrap'
import Icon from 'react-fa'
import {Table} from 'react-bootstrap'
import {t} from '../../helpers/translate'

class ConfirmationScreenComponent extends React.Component {

  getPolicyNumbers() {
    let subheading_length = this.props.data.body.length;
    let policy_numbers = [];
    for (let i = 0; i < subheading_length; i++) {
      let items_length = this.props.data.body[i].items.length;
      for (let j = 0; j < items_length; j++) {
        if (this.props.data.body[i].items[j].text === 'Policy Number') {
          policy_numbers.push(this.props.data.body[i].items[j].value)
        }
      }
    }
    return policy_numbers;
  }

  getPrint() {
    let confirmationDiv = this.refs.confirmationScreen.innerHTML;
    let html = `
      <html>
        <head>
        </head>
        <body>
        <style>
          html {
            font-family: verdana;
          }
        </style>
            <div class="container">
            <div style="margin: 2em">
               ${confirmationDiv}
            </div>
          </div>
        </body>
      </html>
    `;
    let w = window.open();
    w.document.write(html);
    w.document.close();
  }

  showHeaderAlertDiv(){
    return <div className="header-alert" >
      <b>{t('IMPORTANT')}</b><br /><br />
      <p dangerouslySetInnerHTML={{__html: this.props.data.header_alert}}></p>
    </div>
  }

  getView() {
    let policy_numbers = this.getPolicyNumbers().join(',');
    return (
      <div>
        <div>
          <div style={{float: 'left'}}>
            {this.props.data.logos.map((url) => <img style={{'max-height': '60px'}} src={url}/>)}
          </div>
          <div style={{float: 'right'}}>
            <div>{t('Policy Number(s):')}</div>
            <div>{policy_numbers}</div>
          </div>
        </div>
        <div style={{clear: 'left'}}></div>
        <h3>{this.props.data.title}</h3>
        <hr />
        <div dangerouslySetInnerHTML={{__html: this.props.data.header_text}}></div>
        {this.props.data.header_alert && this.showHeaderAlertDiv()}
        <br />
        <div>
          {this.props.data.body.map((group, i) =>
            <div key={i}>
              <h4>{group.header}</h4>
              <div style={{paddingTop: '0.25em', paddingBottom: '0.75em'}}>
                {
                  group.items.map((field, i) => {
                    if (field.text && field.value) {
                      return <div key={i}>
                        <div style={{width: '50%', float: 'left'}}><b>{field.text}</b></div>
                        <div style={{width: '50%', float: 'right'}}>{field.value}</div>
                        <div style={{clear: 'left'}}></div>
                      </div>
                    }
                    return <div style={{paddingBottom: '0.5em'}}></div>
                  })
                }
              </div>
            </div>
          )}
        </div>
        <br />
        <div dangerouslySetInnerHTML={{__html: this.props.data.legal_text}}></div>
        <br />
      </div>
    )
  }

  render() {
    return <div>
      <Button onClick={this.getPrint.bind(this)} className="pull-right"><Icon name="print"/>
        {t(' View Printable Version')}</Button>
      <div className="clearfix"></div>
      <hr />
      <div className="margin">
        <div id='confirmation-screen' ref='confirmationScreen'>
          {this.getView()}</div>
      </div>
    </div>
  }
}
export default ConfirmationScreenComponent;



// WEBPACK FOOTER //
// ./src/components/common/ConfirmationScreenComponent.js